import { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import useKey from 'react-use/lib/useKey';
import { Box } from '../../../../layout/Box';
import { FeedManagementDatePopupContent } from '../FeedManagementDatePopupContent/FeedManagementDatePopupContent';
import { FeedManagementDatePopupProps } from './types';

export const FeedManagementDatePopup: React.FC<FeedManagementDatePopupProps> = ({
    dateFrom,
    dateTo,
    referenceElement,
    onChange,
    onClose,
}) => {
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
    const { styles, attributes, update } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
    });

    useKey('Escape', onClose, {}, [onClose]);

    useEffect(() => {
        update?.();
    }, [update]);

    useEffect(() => {
        const onClickAway = (e: Event) => {
            if (
                !e.target ||
                popperElement === e.target ||
                popperElement?.contains(e.target as any)
            ) {
                return;
            }

            onClose();
            e.stopPropagation();
        };

        window.document.addEventListener('mousedown', onClickAway);
        window.document.addEventListener('touchstart', onClickAway);

        return () => {
            window.document.removeEventListener('mousedown', onClickAway);
            window.document.removeEventListener('touchstart', onClickAway);
        };
    }, [popperElement, onClose]);

    return (
        <Box ref={setPopperElement} zIndex={9999} style={styles.popper} {...attributes.popper}>
            <FeedManagementDatePopupContent
                dateFrom={dateFrom}
                dateTo={dateTo}
                style={styles.offset}
                onChange={onChange}
            />
        </Box>
    );
};
